import React, { useState } from 'react';

import {
  Container,
  Title,
  Subtitle,
  DivTitles,
  DivBack,
  ContainerFluid,
  ContainerMenu,
  CartItemWrapper,
  Overlay,
  CartEmpty,
  TitleEmpty,
  IconEmpty,
  LineCart
} from './styles';
const xIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/xIcon.svg';
import ProgressBorder from '../ProgressBorder';

type HeaderProps = {
  onClose: () => void;
  title?: string;
  nextPage?: string;
  currentStep?: number;
  totalSteps?: number;
};
const Header = ({ onClose, nextPage, title, currentStep, totalSteps }: HeaderProps) => {
  const [isMenuCart, setMenuCart] = useState<boolean>(false);

  return (
    <>
      <Overlay visible={isMenuCart} onClick={() => setMenuCart(!isMenuCart)} />
      <div className="top-wrapper" style={{ position: 'fixed', zIndex: '25', top: 0, left: 0, right: 0 }}>
        <div className="" style={{ position: 'relative' }}>
          <ContainerFluid>
            <Container>
              <DivBack onClick={() => onClose()}>
                <img src={xIcon} alt="reset" />
              </DivBack>
              <DivTitles>
                <Title>{title}</Title>
                {/* {nextPage && <Subtitle>Etapa seguinte: {nextPage}</Subtitle>} */}
              </DivTitles>
              {/* <DivCart
                onClick={() => {
                  setMenuCart(!isMenuCart);
                }}
              >
                <img src={cartIcon} alt="carrinho" />
                {!!quantity && (
                  <CountCart>
                    {quantity < 10 ? `0${quantity}` : quantity}
                  </CountCart>
                )}
              </DivCart> */}
            </Container>
            {<ProgressBorder currentStep={currentStep || 0} totalSteps={totalSteps || 0} />}
          </ContainerFluid>
          {/* <ContainerMenu visible={isMenuCart}> */}
          {/* <ul className="services-list">
              {productList?.length >= 1 ? (
                <>
                  <LineCart />
                  {productList.map((serviceItem: ProductItemProps, index) => (
                    <CartItemWrapper key={index + serviceItem.id}>
                      <ServiceItem
                        disabled={router.route !== PAGES.SERVICE_LIST.id && router.route !== PAGES.PATIENT_FORM.id}
                        product={serviceItem}
                        border={true}
                      />
                    </CartItemWrapper>
                  ))}
                </>
              ) : (
                <CartEmpty>
                  <IconEmpty>!</IconEmpty>
                  <TitleEmpty>O carrinho está vazio</TitleEmpty>
                </CartEmpty>
              )}
            </ul> */}
          {/* <ProgressBorder currentStep={currentStep || 0} totalSteps={totalSteps || 0} /> */}
          {/* </ContainerMenu> */}
        </div>
      </div>
    </>
  );
};

export default Header;
